module.exports = __webpack_public_path__ + "static/media/12UNCTAD12.05be9d8d.jpg";